export default function genererTypeFormatPresse(societeId) {
  return {
    societeId: societeId,
    libelle: '',
    code: '',
    typeFormatPresseLignes: [],
  };
}
